export default {
  email: {
    label: "ssg-field-label",
    input: "ssg-forms-input full-width"
  },
  specialText: {
    label: "ssg-field-label",
    text: "ssg-forms-input full-width"
  }
};



// WEBPACK FOOTER //
// src/acct/account-widget.style.js